import { z } from 'zod';
import { defineEndpoint } from '../define';

export const GitCommitSchema = z.object({
  sha: z.string(),
  message: z.string(),
  /** ISO committer date; '' when GitHub omitted it. */
  date: z.string(),
});
export type GitCommit = z.infer<typeof GitCommitSchema>;

/**
 * Latest 10 commits of `ref` (default branch when omitted). Passing `sha`
 * looks a single commit up directly (full or short SHA) instead.
 */
export const listGitCommits = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/git/commits',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({
    ref: z.string().optional(),
    sha: z.string().optional(),
  }),
  body: z.undefined(),
  response: z.object({ data: z.array(GitCommitSchema) }),
});
